const root = 'ShippingInformationForm'

export const TestId = {
  root,
  sameAsBusinessInformation: `${root}-sameAsBusinessInformation`,
  contactName: `${root}-contactName`,
  organizationName: `${root}-organizationName`,
  address: `${root}-address`,
  zipCode: `${root}-zipCode`,
  city: `${root}-city`,
  state: `${root}-state`,
  country: `${root}-country`,
  countrySelect: `${root}-country-countrySelect`,
  phoneNumber: `${root}-phoneNumber`,
  submitButton: `${root}-submitButton`,
  discardButton: `${root}-discardButton`,
}
